export default __webpack_public_path__ + "static/media/explore-mobile-3.f84aa448.png";